import {
  Component,
  Input,
  OnInit,
  ViewChild,
  AfterViewInit,
  EventEmitter,
  Output,
  ViewEncapsulation,
  SimpleChanges,
} from "@angular/core";
import {
  MatDialogRef,
  MatDialog,
  MatDialogConfig,
} from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { AlertifyService } from "src/app/pages/Shared/_services/alertify.service";
import { AppAuthService } from "src/app/pages/Shared/_services/auth.service";
import { DeliveryToEmployeeService } from "src/app/pages/Shared/_services/delivery-to-employee.service";
import { EmployeeService } from "src/app/pages/Shared/_services/employee.service";
import { EmployeeUploadService } from "src/app/pages/Shared/_services/employeeUpload.service";
import { UiSyncService } from "src/app/pages/Shared/_services/ui-sync.service";
import { FileSizeEnum } from "src/app/_enums/FileSizeEnum";
import { EmployeeDeliveriesOutputDto } from "src/app/_models/dto/employeedeliveriesoutputdto";
import { EmployeeInfo } from "src/app/_models/EmployeeModels/employee-info";
import { Ethnicity } from "src/app/_models/ethnicity";
import { environment } from "src/environments/environment";
import { EmployeeHeaderComponent } from "../employee-header/employee-header.component";
import { ImageFramingCropingComponent } from "../image-framing-croping/image-framing-croping.component";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { event } from "jquery";
import { SignalRService } from "src/app/pages/Shared/_services/signalR.service";
import { PersonTypeEnum } from "src/app/_enums/person-type-enum";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatCheckboxChange } from "@angular/material/checkbox";

@Component({
  selector: "app-employee-profile",
  templateUrl: "./employee-profile.component.html",
  styleUrls: ["./employee-profile.component.css"],
})
export class EmployeeProfileComponent implements OnInit {
  @ViewChild(ImageFramingCropingComponent, { static: false })
  imageFramingCropingComponent: ImageFramingCropingComponent;
  loading = true;

  @Input("isShowEmployeeProfile") isShowProfile = false;
  @Output("onClosePopup") employeeProfileClose = new EventEmitter<boolean>();
  @Output("onLoggedOut") loggedOut = new EventEmitter<boolean>();

  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  loadingProfileIamge = true;
  loadingCareerImage = true;
  isEmployee: boolean = false;
  isOtpLoginEnabledStatusChanged: boolean;
  isSmsOptionStatusChanged: boolean;
  editEnabled: boolean = false;
  hasChanges: boolean;
  isSmsOptionProcessing: boolean;
  isOtpLoginEnabledProcessing: boolean;
  isStudentInfoChange: boolean;
  isProfileLoading: boolean;
  currentPersonType: PersonTypeEnum;
  isApplicant: boolean = false;

  baseUrl = environment.baseS3ImageUrl;
  careerImageUrl: any = "assets/images/career-details-default-image-large.png";
  employeeInfo: EmployeeInfo = new EmployeeInfo();
  hasManager = null;
  currentUser: any;
  employee: EmployeeDeliveriesOutputDto;
  baseAuthUrl = environment.baseAppImageUrl;
  jobRecommendations: any[];
  testResult: any;
  deliveries: any;
  jobRecommendationsLenght: boolean;
  workValues: any;
  catalyzrPersonId: string;
  clientId: any;
  isSelectAboutUs: boolean;
  // isSelectAboutUs: boolean;
  isSelectLogin: boolean;
  loginUser: any;

  isRelocate: any;
  isRelocateY: boolean;
  isRelocateN: boolean;

  selectedAge: number;
  selectedGender: string = "";
  selectedEthnicityId: number;
  imageUrl: any = "assets/images/user-image.jpg";
  userImage: any;
  fileToUpload: File = null;
  fileName: string;
  fileFormat: string;
  ages: number[] = [];
  ethnicities: Ethnicity[] = [];
  selectedEthnicityIds: number[] = [];

  selectedRaces = [];
  data = [];

  showPopup: boolean = false;
  otpLoginEnabled: boolean;
  disableToggole: boolean;
  employeeForm: FormGroup;
  gpaValues: number[] = [];
  degreeTypes: string[] = [];
  targetGraduationDates: number[] = [];
  enableUpdateButton: boolean;
  isProcessing: boolean;
  isStudent: boolean = false;
  isShowPopup: boolean;
  smsOption: boolean;
  disableSmsOption: boolean;
  disableUploadProfile: boolean;
  constructor(
    private deliveryService: DeliveryToEmployeeService,
    private authService: AppAuthService,
    private route: Router,
    public dialog: MatDialog,
    public alertifyService: AlertifyService,
    private employeeService: EmployeeUploadService,
    private uiSyncService: UiSyncService,
    private employeeCoreService: EmployeeService,
    private sanitizer: DomSanitizer,
    private signalRService: SignalRService,
    private fb: FormBuilder,
  ) {
    this.currentUser = this.authService.currentUser;

    this.catalyzrPersonId = this.currentUser.catalyzrPersonId;
    this.clientId = this.currentUser.clientId;
    if (this.currentUser.catalyzrPersonId) {
      this.otpLoginEnabled = this.currentUser.isOTPEnabled;
      this.smsOption = this.currentUser.isSMSEnabled;
    } else {
      this.otpLoginEnabled = false;
      this.disableUploadProfile = true;
      this.disableToggole = true;
      this.disableSmsOption = true;
    }
    this.employeeForm = this.fb.group({
      personType: [""],
      major: [""],
      gpa: [""],
      degreeType: [""],
      targetGraduationDate: [""],
    });
    for (let i = 0; i <= 50; i++) {
      this.gpaValues.push(parseFloat((i / 10).toFixed(1)));
    }

    this.populateGraduationDates(2024, 2060);
  }

  async ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: "id",
      textField: "name",
      itemsShowLimit: 1,
      enableCheckAll: false,
      defaultOpen: false,
    };
    this.employeeAges();
    await this.GetEmployeeByCatalyzrPersonIdAndClientId();
    if (this.authService.currentUser) {
      await this.authService.getEmployeeImageUrl();
    }
    this.getEthnicities();
    this.employeeForm.valueChanges.subscribe((formValues) => {
      this.enableUpdateButton = true;
    });
  }
  async ngOnChanges(changes: SimpleChanges) {
    if (
      changes["isShowProfile"] &&
      changes["isShowProfile"].currentValue === true
    ) {
      // isShowProfile just became true
      this.currentPersonType = this.uiSyncService.currentUserPersonType;
      await this.GetEmployeeByCatalyzrPersonIdAndClientId();
    }
  }
  populateGraduationDates(startYear: number, endYear: number) {
    for (let year = startYear; year <= endYear; year++) {
      this.targetGraduationDates.push(year);
    }
  }
  onItemSelect(item: any) {
    this.hasChanges = true;
    console.log(this.selectedRaces);
    console.log(item);
    this.selectedEthnicityIds.push(item.id);
  }
  onDeSelectItem(event: any) {
    this.hasChanges = true;
    for (let i = 0; i <= this.selectedEthnicityIds.length; i++) {
      if (this.selectedEthnicityIds[i] === event.id) {
        this.selectedEthnicityIds.splice(i, 1);
      }
    }
  }
  // ages
  employeeAges() {
    for (let i = 18; i <= 99; i++) {
      this.ages.push(i);
    }
  }

  setPersonByType(personType?: string) {
    if (PersonTypeEnum.Student == personType) {
      this.isStudent = true;
      this.isApplicant = false;
      this.isEmployee = false;
    } else if (PersonTypeEnum.Applicant == personType) {
      this.isStudent = false;
      this.isApplicant = true;
      this.isEmployee = false;
    } else if (
      PersonTypeEnum.Employee == personType ||
      PersonTypeEnum.ContingentLabor == personType
    ) {
      this.isStudent = false;
      this.isApplicant = false;
      this.isEmployee = true;
    } else {
      this.isStudent = false;
      this.isApplicant = false;
      this.isEmployee = false;
    }
  }
  onClosePopup() {
    this.isShowPopup = false;
  }
  popupShow() {
    this.isShowPopup = true;
  }

  async GetEmployeeByCatalyzrPersonIdAndClientId() {
    if (!this.catalyzrPersonId) {
      this.setPersonByType();
      return;
    }
    this.isProfileLoading = true;
    this.employeeCoreService
      .getEmployeeProfile(this.catalyzrPersonId, this.clientId)
      .subscribe(
        (response) => {
          this.isProfileLoading = false;
          if (response) {
            this.employeeInfo = response;
            if (response?.degreeTypes?.length) {
              this.degreeTypes = response.degreeTypes.map((c) => c.name);
            }
            this.employeeForm.patchValue(this.employeeInfo);
            this.setPersonByType(response.personType);

            if (
              this.employeeInfo.currentCareerOSOCCode === null ||
              this.employeeInfo.currentCareerOSOCCode === undefined
            ) {
              this.employeeInfo.currentCareerOSOCCode = "";
            }
            if (
              this.employeeInfo.careerImageUrl === null ||
              this.employeeInfo.careerImageUrl === undefined ||
              this.employeeInfo.careerImageUrl === ""
            ) {
              this.careerImageUrl =
                "assets/images/career-details-default-image-large.png";
            } else {
              this.careerImageUrl = this.createS3ImgPath(
                this.employeeInfo.careerImageUrl + FileSizeEnum.small,
              );
            }
            if (
              this.employeeInfo.manager === null ||
              this.employeeInfo.manager === undefined ||
              this.employeeInfo.manager === ""
            ) {
              this.hasManager = false;
            } else {
              this.hasManager = true;
            }
            if (this.employeeInfo.isRelocate === null) {
              this.isRelocateY = false;
              this.isRelocateN = false;
            } else {
              if (this.employeeInfo.isRelocate === true) {
                this.isRelocateY = true;
                this.isRelocateN = false;
              } else {
                this.isRelocateY = false;
                this.isRelocateN = true;
              }
            }
            this.selectedEthnicityIds = response.seletedEthnicityIds;
          }
          let employee: EmployeeDeliveriesOutputDto =
            new EmployeeDeliveriesOutputDto();
          employee.firstName = this.currentUser.firstName;
          employee.middleName = this.currentUser.middleName;
          employee.lastName = this.currentUser.lastName;
          employee.catalyzrPersonId = this.currentUser.catalyzrPersonId;
          if (response != null && response != undefined) {
            employee.personType = response.personType;
            employee.schoolName = response.schoolName;
            employee.degreeType = response.degreeType;
            employee.gpa = response.gPA;
            employee.major = response.major;
            employee.targetGraduationDate = response.targetGraduationDate;
          }

          if (
            employee.middleName !== null &&
            employee.middleName !== undefined &&
            employee.middleName !== ""
          ) {
            employee.employeeName =
              employee.firstName +
              " " +
              employee.middleName +
              " " +
              employee.lastName;
          } else {
            employee.employeeName =
              employee.firstName + " " + employee.lastName;
          }
          this.employee = employee;
          //this.selectedGender = response.gender;
          //this.selectedAge = response.age;
          if (response != null || response != undefined) {
            this.selectedEthnicityId = response.ethnicityId;
            if (
              response.imageUrl !== null &&
              response.imageUrl !== undefined &&
              response.imageUrl !== ""
            ) {
              this.userImage = response.imageUrl;
              if (
                this.userImage !== null &&
                this.userImage !== undefined &&
                this.userImage !== ""
              ) {
                this.imageUrl = this.createImgPath(this.userImage);
              }
            }
          }
        },
        (error) => {
          this.isProfileLoading = false;
          console.log(error);
        },
      );
  }
  handleFileInput(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fileName = this.fileToUpload.name;
    this.fileFormat = this.fileName.slice(
      ((this.fileName.lastIndexOf(".") - 1) >>> 0) + 2,
    );
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageUrl = event.target.result;
      this.showPopup = true;
      //this.uploadProfileImage(this.imageUrl, this.fileName, this.fileFormat);
    };
    reader.readAsDataURL(this.fileToUpload);
  }
  public createS3ImgPath = (serverPath: string) => {
    var data = encodeURIComponent(serverPath);
    return this.baseUrl + `${data}`;
  };
  public createImgPath = (serverPath: string) => {
    var data = encodeURIComponent(serverPath);
    return this.baseUrl + `${data}`;
  };

  // this is a function to close dialog

  // closeDialog() {
  //   const empProfile = this.prepareSave();
  //   this.employeeService.updateEmpProfile(empProfile).subscribe(async (response) => {
  //     await this.authService.getEmployeeImageUrl();
  //   }, error => {
  //     console.log(error);
  //   });
  // }
  onAgeChange(value) {
    this.selectedAge = +value;
  }
  private prepareSave(updateEmployeeProfile?: any): any {
    const profileForm = new FormData();
    // if (this.selectedGender === 'undefined' || this.selectedGender == null) {
    //   profileForm.append('gender', '');
    // } else {
    //   profileForm.append('gender', this.selectedGender);
    // }
    profileForm.append("catalyzrPersonId", this.currentUser.catalyzrPersonId);
    profileForm.append("employeeId", this.employeeInfo.employeeId);
    profileForm.append("clientId", this.currentUser.clientId);

    if (
      this.selectedEthnicityIds != undefined &&
      this.selectedEthnicityIds != null
    ) {
      profileForm.append("ethnicityIds", this.selectedEthnicityIds.join(","));
    }
    // profileForm.append('age', this.selectedAge.toString());

    if (this.isRelocateY === true) {
      profileForm.append("isWillingToRelocate", "true");
    } else if (this.isRelocateN === true) {
      profileForm.append("isWillingToRelocate", "false");
    } else {
      profileForm.append("isWillingToRelocate", "");
    }
    if (updateEmployeeProfile) {
      profileForm.append("degreeType", updateEmployeeProfile?.degreeType);
      profileForm.append("gpa", updateEmployeeProfile?.gpa);
      profileForm.append("major", updateEmployeeProfile?.major);
      if (updateEmployeeProfile?.targetGraduationDate) {
        profileForm.append(
          "targetGraduationDate",
          updateEmployeeProfile.targetGraduationDate,
        );
      }
    }
    profileForm.append("file", this.fileToUpload);
    return profileForm;
  }
  logout() {
    if (this.hasChanges) {
      this.cancelClick();
      return;
    }
    this.employeeProfileClose.emit(false);
    this.uiSyncService.onLoggedOut.next(true);
    this.isSelectAboutUs = false;
    this.isSelectLogin = false;
    // this.isSelectSignUp = false;
    this.authService.logout();
    this.authService.currentUser = null;
    this.loginUser = null;
    this.loggedOut.emit(true);
    localStorage.removeItem("searchKey");
    localStorage.removeItem("career");
    localStorage.removeItem("people");
    localStorage.removeItem("facetedSelection");
    localStorage.removeItem("selectedRoleId");
    localStorage.removeItem("selectedClientId");
    localStorage.removeItem("selectedClientName");
    localStorage.removeItem("careerGroupName");
    localStorage.removeItem("hrNavigateRoute");
    localStorage.removeItem("employeeNavigateRoute");
    this.uiSyncService.selectedRoleId = 0;
    this.uiSyncService.selectedClientId = 0;
    this.uiSyncService.selectedClientName = "";
    this.uiSyncService.onClientSelected.next(null);
    this.uiSyncService.onSelectedClientName.next(null);
    this.uiSyncService.onClientSelectionForAQBReporting.next(null);
    // this.uiSyncService.onSelectedClientName.complete();
    // this.uiSyncService.onClientSelected.complete();
    this.uiSyncService.userAllRoles.next([]);
    this.uiSyncService.isDisableClientDropdown.next(null);
    this.uiSyncService.clientLogoUrl.next(
      "assets/images/catalyzr-logo-white.png",
    );
    // this.router.navigate(['/login']);
    // this.dialogRef.close(true);
    this.route.navigate(["/auth/login"]);
    console.log("Logged Out!");
    this.uiSyncService.employeeImageUrl.next(null);

    //Disconnect signalR
    this.signalRService.disconnect();

    this.alertifyService.message("Logout Successfully!");
  }

  onChangeProfile(updateEmployeeProfile?: any) {
    let empProfile;
    if (updateEmployeeProfile) {
      empProfile = this.prepareSave(updateEmployeeProfile);
    } else {
      empProfile = this.prepareSave();
    }
    this.employeeCoreService
      .updateEmpProfile(
        empProfile,
        this.currentUser.catalyzrPersonId,
        this.currentUser.clientId,
      )
      .subscribe(
        async (response) => {
          this.isProcessing = false;
          this.enableUpdateButton = false;
          this.editEnabled = false;
          this.hasChanges = false;
          this.authService.isUpdateUserProfile.next(true);
          await this.authService.getEmployeeImageUrl();
        },
        (error) => {
          this.isProcessing = false;
          this.hasChanges = false;
          console.log(error);
        },
      );
  }

  WillRelocate(isClickedYes, isChecked) {
    debugger;
    this.hasChanges = true;
    if (isClickedYes && isChecked) {
      this.isRelocateY = true;
      this.isRelocateN = false;
    } else if (isClickedYes && !isChecked) {
      this.isRelocateY = false;
    } else if (!isClickedYes && isChecked) {
      this.isRelocateY = false;
      this.isRelocateN = true;
    } else {
      this.isRelocateN = false;
    }
  }

  closeEmployee() {
    if (this.hasChanges) {
      this.cancelClick();
      return;
    }
    this.employeeProfileClose.emit(false);
  }
  OnChange() {
    debugger;
    alert("Hi");
  }
  // all ethnicities
  getEthnicities() {
    this.employeeService.getEthnicities().subscribe(
      (response: Ethnicity[]) => {
        this.ethnicities = response;
        console.log(this.ethnicities);
        console.log("all");
        if (
          this.ethnicities !== null &&
          this.ethnicities !== undefined &&
          this.ethnicities.length > 0
        ) {
          this.ethnicities.forEach((ethnicity) => {
            this.data.push({
              id: ethnicity.id,
              name: ethnicity.name,
            });
          });
          if (
            this.selectedEthnicityIds !== null &&
            this.selectedEthnicityIds !== undefined &&
            this.selectedEthnicityIds.length > 0
          ) {
            this.selectedEthnicityIds.forEach((id) => {
              var existingEthnicity = this.ethnicities.find((c) => c.id === id);
              if (
                existingEthnicity !== null &&
                existingEthnicity !== undefined
              ) {
                this.selectedRaces.push({
                  id: existingEthnicity.id,
                  name: existingEthnicity.name,
                });
              }
            });
          }
        }
      },
      (error) => {
        this.alertifyService.error("There are no ethnicity found.");
      },
    );
  }

  // on click current career
  onClickCurrentCareer() {
    // this.dialogRef.close();
    // localStorage.setItem('FromEmployeeProfile', 'true');
    // this.route.navigate(['/employee/career-details', this.catalyzrPersonId, this.clientId, this.employeeInfo.clientJobCode, this.employeeInfo.currentCareerOSOCCode]);
  }

  onLoadProfileIamge() {
    this.loadingProfileIamge = false;
  }
  onLoadCareerImage() {
    this.loadingCareerImage = false;
  }

  afterApplyCrop($event) {
    this.hasChanges = true;
    this.fileToUpload = $event;
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageUrl = event.target.result;
      this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(this.imageUrl);
    };
    reader.readAsDataURL(this.fileToUpload);
  }

  closeShowPopup($event) {
    this.showPopup = $event;
  }
  onToggleChange(event: MatSlideToggleChange) {
    this.otpLoginEnabled = event.checked;
    this.isOtpLoginEnabledStatusChanged = true;
    this.hasChanges = true;
  }

  applyChanges(event: MatCheckboxChange) {
    this.smsOption = event.checked;
    this.isSmsOptionStatusChanged = true;
    this.hasChanges = true;
  }

  onSubmit(): void {
    if (!this.hasChanges) {
      return;
    }

    if (this.employeeForm.valid && this.hasChanges) {
      if (this.isStudentInfoChange) {
        const updatedData = this.employeeForm.value;
        this.onChangeProfile(updatedData);
      } else {
        this.onChangeProfile();
      }
      this.isProcessing = true;
    }
    if (this.isOtpLoginEnabledStatusChanged) {
      this.isOtpLoginEnabledProcessing = true;
      this.authService
        .updateUserLoginOtpStatus(this.currentUser.id, this.otpLoginEnabled)
        .subscribe({
          next: (res) => {
            this.hasChanges = false;
            this.isOtpLoginEnabledProcessing = false;
            this.isOtpLoginEnabledStatusChanged = false;
            this.currentUser.isOTPEnabled = this.otpLoginEnabled;
            this.authService.currentUser.isOTPEnabled = this.otpLoginEnabled;
            localStorage.removeItem("user");
            localStorage.setItem("user", JSON.stringify(this.currentUser));
            console.log("OTP login status updated successfully:", res);
          },
          error: (err) => {
            this.hasChanges = false;
            this.isOtpLoginEnabledProcessing = false;
            this.isOtpLoginEnabledStatusChanged = false;
            this.otpLoginEnabled = !this.otpLoginEnabled;
            this.alertifyService.error("Failed to update OTP login status");
            console.error("Failed to update OTP login status:", err);
          },
        });
    }
    if (this.isSmsOptionStatusChanged) {
      this.isSmsOptionProcessing = true;
      this.authService
        .updateSmsOptionStatus(this.currentUser.id, this.smsOption)
        .subscribe({
          next: (res) => {
            this.hasChanges = false;
            this.isSmsOptionProcessing = false;
            this.isSmsOptionStatusChanged = false;
            this.currentUser.isSMSEnabled = this.smsOption;
            this.authService.currentUser.isSMSEnabled = this.smsOption;
            localStorage.removeItem("user");
            localStorage.setItem("user", JSON.stringify(this.currentUser));
            console.log("SMS status updated successfully:", res);
          },
          error: (err) => {
            this.hasChanges = false;
            this.isSmsOptionStatusChanged = false;
            this.isSmsOptionProcessing = false;
            this.smsOption = !this.smsOption;
            this.alertifyService.error("Failed to update SMS status");
            console.error("Failed to update SMS status:", err);
          },
        });
    }
  }
  enableEditOption() {
    this.editEnabled = true;
  }
  onFieldChange(event: any) {
    this.hasChanges = true; // Set to true when a field is changed
    this.isStudentInfoChange = true;
  }
  cancelClick() {
    if (this.hasChanges) {
      // Show confirmation dialog if there are unsaved changes
      this.alertifyService.confirmWarningOnCancel(
        "Discard Changes",
        "You have unsaved changes. Do you want to discard them?",
        () => {
          // User confirmed discard, reset and close profile
          this.isShowProfile = false;
          this.hasChanges = false; // Reset changes flag
          this.editEnabled = false;
        },
        () => {
          console.log("Cancel clicked. Changes are not discarded.");
        },
      );
    } else {
      // No changes, just close the profile
      this.editEnabled = false;
    }
  }
  getPersonType(personType: string): string {
    const map: Record<string, string> = {
      A: "Applicant",
      E: "Employee",
      C: "Contingent Labor",
      S: "Student",
    };

    return map[personType] ?? "";
  }

  changePassword() {
    // Navigate to the change password component
    this.isShowProfile = false;
    this.route.navigate(["/auth/change-password"]);
  }
}
